import { render, staticRenderFns } from "./SummaryErrors.vue?vue&type=template&id=ecd766d8"
import script from "./SummaryErrors.vue?vue&type=script&lang=ts"
export * from "./SummaryErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports